import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
  responsiveFontSizes,
} from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import {
  LocalizationProvider,
} from '@mui/x-date-pickers';
import {
  frFR as pickersFrLocale,
  enUS as pickersEnLocale,
} from '@mui/x-date-pickers/locales';
import { fr as frLocale, enGB as enLocale } from 'date-fns/locale';
import {
  frFR,
  enUS,
} from '@mui/material/locale';
import i18next from 'i18next';
import { CONSTANTS } from 'generic/core/constants';
import { useColorSchemeDetector } from 'generic/core/hooks/useColorSchemeDetector';

const { LANG_MAPPING } = CONSTANTS;
// classes utilisables dans toute l'application

const ConfigWrapper = ({ children }) => {
  const [currentDateLocale, setCurrentDateLocale] = useState(frLocale);
  const [currentThemeLocale, setCurrentThemeLocale] = useState(frFR);
  const [currentPickersLodale, setCurrentPickersLodale] = useState(pickersFrLocale);
  const logged = useSelector((state) => state.auth.logged);
  const lang = useSelector((state) => (state.auth.logged ? state.config.user.langue : 1));
  const dispatch = useDispatch();
  const currentTheme = useColorSchemeDetector();

  useEffect(() => {
    if (logged) {
      const localeDateMapping = {
        1: frLocale,
        2: enLocale,
      };
      const localeThemeMapping = {
        1: frFR,
        2: enUS,
      };
      const localePickersMapping = {
        1: pickersFrLocale,
        2: pickersEnLocale,
      };
      setCurrentDateLocale(localeDateMapping[lang]);
      setCurrentThemeLocale(localeThemeMapping[lang]);
      setCurrentPickersLodale(localePickersMapping[lang]);

      window.QWAM = {
        localeId: lang,
      };
      i18next.changeLanguage(LANG_MAPPING[lang], (err) => {
        if (err) {
          console.warn('un problème est survenu au changement de langue', err);
        }
      });
    }
  }, [dispatch, logged, lang]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={responsiveFontSizes(createTheme(currentTheme.THEME, currentThemeLocale))}>
        <CssBaseline enableColorScheme />
        <GlobalStyles styles={currentTheme.GLOBAL_STYLES} />
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={currentDateLocale}
          localeText={currentPickersLodale.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          {children}
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

ConfigWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConfigWrapper;
